import { render } from "./mdoorwallsystem.vue?vue&type=template&id=0278e0d0&scoped=true"
import script from "./mdoorwallsystem.vue?vue&type=script&lang=js"
export * from "./mdoorwallsystem.vue?vue&type=script&lang=js"

import "./mdoorwallsystem.vue?vue&type=style&index=0&id=0278e0d0&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0278e0d0"]])

export default __exports__